import { render, staticRenderFns } from "./SettingsSpecificOutcome.vue?vue&type=template&id=639b19a5"
import script from "./SettingsSpecificOutcome.vue?vue&type=script&lang=js"
export * from "./SettingsSpecificOutcome.vue?vue&type=script&lang=js"
import style0 from "./SettingsSpecificOutcome.vue?vue&type=style&index=0&id=639b19a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports